import { createPricingService } from "../shared/service.share.pricing";
import { PRICING_PAGE_CONFIG } from "./config.pricing";

export const PricingService = createPricingService({
  config: PRICING_PAGE_CONFIG,
  content: undefined,
});

export type TPricingService = typeof PricingService;
